import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  loading: false,
  fetchedLocation: false,
  pagination: {},
  locations: [],
  location: {},
  fetchingDeleteLocation: false,
  errors: {},
};

const locationReducer = createReducer(initialState)({
  // GET LOCATIONS
  [types.FETCH_LOCATIONS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_LOCATIONS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      locations: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_LOCATIONS_FAILED]: (state, { error }) => {
    return {
      ...state,
      loading: false,
      locations: [],
      errors: {
        locations: error,
      },
    };
  },
  // GET LOCATIONS BY ID
  [types.FETCH_LOCATIONS_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_LOCATIONS_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      location: payload,
    };
  },
  [types.FETCH_LOCATIONS_BY_ID_FAILED]: (state, { error }) => {
    return {
      ...state,
      loading: false,
      location: {},
      errors: {
        locations: error,
      },
    };
  },
  // CREATE LOCATION
  [types.CREATE_LOCATION_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedLocation: false,
    };
  },
  [types.CREATE_LOCATION_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      fetchedLocation: true,
      location: payload,
      errors: {},
    };
  },
  [types.CREATE_LOCATION_FAILED]: (state, { errors }) => {
    return {
      ...state,
      loading: false,
      fetchedLocation: false,
      errors: {
        location: errors,
      },
    };
  },
  // UPDATE LOCATION
  [types.UPDATE_LOCATION_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedLocation: false,
    };
  },
  [types.UPDATE_LOCATION_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
      location: {},
      fetchedLocation: true,
      errors: {},
    };
  },
  [types.UPDATE_LOCATION_FAILED]: (state, { errors }) => {
    return {
      ...state,
      loading: false,
      fetchedLocation: false,
      errors: {
        location: errors,
      },
    };
  },
  // DELETE LOCATION
  [types.DELETE_LOCATION_REQUEST]: (state) => {
    return {
      ...state,
      fetchingDeleteLocation: true,
    };
  },
  [types.DELETE_LOCATION_SUCCESS]: (state) => {
    return {
      ...state,
      fetchingDeleteLocation: false,
      errors: {},
    };
  },
  [types.DELETE_LOCATION_FAILED]: (state, { errors }) => {
    return {
      ...state,
      fetchingDeleteLocation: false,
      errors: {
        location: errors,
      },
    };
  },
  // RESET LOCATION STATE
  [types.RESET_LOCATION_STATE_REQUEST]: (state) => {
    return {
      ...state,
      loading: false,
      fetchedLocation: false,
      location: {},
      errors: {},
    };
  },
});

export default locationReducer;
